import axios from "axios";
import { IDataDefaulFilter } from "../../pages/AnalysisReport/ReportCustomer";
import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessNonData, ResponseSuccessReport, ResponseSuccessTotal, ResponseSuccessTotalReportVoucher, ResponseSuccessTotalV3 } from "../axiosClient";
import { IPermissionMenu } from "../customer/customerApi";
import { API_URL } from "../../env";
import dayjs from "dayjs";
import tokenService from '../../services/token';
import { ListFieldCustomer, PermissionMenu } from "../Customer_V2/customerApi_V2";

export type IReportCampaignCustomerAddress = {
  province: string
  total: number
  id: number
}

export type IReportCampaignCustomerAddressV2 = {
  provinceName: string
  provinceId: number
  total: number
}

export type IReportCampaignCustomerJob = {
  profession: string
  total: number
  id: number
}

export type IReportCampaignCustomerJobV2 = {
  jobName: string
  jobId: number
  total: number
}

export type IReportCampaignDemographics = {
  gender: {
    totalCustomer: number
    totalMale: number
    totalFemale: number
    totalElse: number
  }
  businessCheck: {
    totalCustomer: number
    totalIndividual: number
    totalBusiness: number
  }
  statusMarital: {
    totalCustomer: number
    totalSingle: number
    totalMarried: number
    totalElse: number
  }
}

export type IReportCampaignVehicleDistributionByAge = {
  totalCustomer: number
  undetermined: number
  ageUnder18: number
  ageBetween1825: number
  ageBetween2635: number
  ageBetween3645: number
  ageBetween4655: number
  ageOver55: number
}

export type IReportCampaignVehicleDistributionByAgeV2 = {
  totalCustomer: number
  undetermined: number
  ageUnder20: number
  ageBetween2025: number
  ageBetween2629: number
  ageBetween3039: number
  ageBetween4049: number
  ageBetween5059: number
  ageOver60: number
}

export interface List {
  id: number,
  code: string,
  name: string,
  unitTitle: string,
  nameCare: string,
  totalCare: number,
  groupTitle: string
  permissionMenu: IPermissionMenu
}
export interface Customer {
  total: number
  list: List[]
}
export interface ListGroupCustomer {
  id: number
  title: string
  totalCustomersInGroup: number
  totalCaredCustomersInGroup: number
  totalCareVisitsInGroup: number
  totalUncaredCustomersInGroup: number
  carePercentageInGroup: number
}
export interface ISummary {
  totalCustomersInGroupAll: number
  totalCaredCustomersInGroupAll: number
  totalCareVisitsInGroupAll: number
  totalUncaredCustomersInGroupAll: number
}
export interface GroupCustomer {
  total: number
  list: ListGroupCustomer[]
  summary: ISummary
}
export interface IReportCustomer {
  listCustomer: Customer
  listGroupCustomer: GroupCustomer
}
export interface IReportFilter {
  date?: string[];
  idgroupCustomer?: number[];
  search?: string;
  unitId?: number
  adminId?: number
}

export interface IGender {
  totalCustomer: number
  totalMale: number
  totalFemale: number
  totalElse: number
}

export interface IBusinessCheck {
  totalCustomer: number
  totalIndividual: number
  totalBusiness: number
}

export interface IReportGenderBussiness {
  gender: IGender
  businessCheck: IBusinessCheck
}

export interface IReportJob {
  profession: string
  total: number
}


export interface IReportAddress {
  province: string
  id: number
  total: number
}

export interface IReportJobs {
  profession: string
  total: number
  id: number
}


export interface IReportAgeDetail {
  interaction: number
  invoiceSale: number
  invoiceService: number
}

export interface IReportAge {
  undetermined: IReportAgeDetail
  ageUnder18: IReportAgeDetail
  ageBetween1825: IReportAgeDetail
  ageBetween2635: IReportAgeDetail
  ageBetween3645: IReportAgeDetail
  ageBetween4655: IReportAgeDetail
  ageOver55: IReportAgeDetail
}

export interface IReportCarOwnerUsed {
  invoiceSale: number
  invoiceService: number
  interaction: number
}

export interface IReportCarOwnedBrand {
  brand: string
  total: number
}

export interface IReportCustomerByInformationChannel {
  informationChannel: string
  totalCustomers: number
}


export interface IReportBrandOwnership {
  brands: {
    [brand: string]: number
  }
}

export interface IReportBranchOwnership {
  [branch: string]: IReportBrandOwnership
}

export type IVehicleOwnershipReport = {
  one_car: number
  two_car: number
  three_car: number
  four_car: number
  five_car: number
  six_to_ten_car: number
  ten_plus_car: number
}

export const mapFilterToParamsReport = (filter: IDataDefaulFilter) => {
  return {
    unitId: filter.unitId,
    businessCheck: filter.businessCheck,
    gender: filter.gender,
    job: filter.job,
    province: filter.province,
    carBrand: filter.carBrand,
    age: filter.age,
    groupCustomer: filter.group
  };
};

export const mapFilterToParamsReportV2 = (filter: IDataDefaulFilter) => {
  return {
    unitId: filter?.unitId,
    businessCheck: filter?.businessCheck,
    gender: filter?.gender,
    job: filter?.job,
    province: filter?.province,
    age: filter?.age,
    groupCustomer: filter?.group
  };
};

export interface CampaignStats {
  totalSend?: number;
  successSend?: number;
  sendRate?: number;
}

export type IconType = 'zns' | 'email' | 'sms';
export type MucTieuType = 'khuyen-mai' | 'cskh' | 'thong-bao';
export type StatusDot = 'green' | 'red' | 'orange' | 'gray' | 'none';

export interface ChildRow {
  brandName?: string;
  templateTitle?: string;
  logo?: string;
  id?: number;
  name?: string;
  iconType?: IconType;
  status?: string;
  statusDot?: StatusDot;
  zns?: CampaignStats;
  sms?: CampaignStats;
  email?: CampaignStats;
}

export interface IReportCampaign {
  id: number;
  title?: string;
  name?: string;
  auto?: number;
  groupCustomer?: string;
  dateSend?: string;
  timeSend?: string;
  totalDeposit?: number;
  target: {
    id?: number;
    title?: string;
    icon?: string;
    colorBorder?: string;
    bgColor?: string;
    colorText?: string | null;
  };
  totalCustomerTarget?: number;
  avgAge?: number;
  creationDate?: string;
  status: number;
  trangThai?: string;
  mucTieu?: string;
  mucTieuType?: MucTieuType;
  nhomKH?: string;
  khachHang?: string | number;
  zns?: CampaignStats;
  sms?: CampaignStats;
  email?: CampaignStats;
  children: ChildRow[];
}

export interface TotalRow {
  zns: CampaignStats;
  sms: CampaignStats;
  email: CampaignStats;
}


export interface ICustomerMemberRankSummary {
  totalMembers: number
  newMembersInMonth: number
  growthRate: number
  avgAge: number
}

export type IChartCustomerReportRank = {
  rankId: number
  rankName: string
  code: string
  icon: any
  count: number
  rate: number
  percentage: number
}

export type IChartMemberFluctuation = {
  year: number
  totalCustomers: number
  growthCount: number
  growthRate: number
}

export type IListMemberGrowthMonthly = {
  rankId: number
  rankName: string
  months: {
    T1: {
      growthCount: number
      cumulativeCount: number
    }
    T2: {
      growthCount: number
      cumulativeCount: number
    }
    T3: {
      growthCount: number
      cumulativeCount: number
    }
    T4: {
      growthCount: number
      cumulativeCount: number
    }
    T5: {
      growthCount: number
      cumulativeCount: number
    }
    T6: {
      growthCount: number
      cumulativeCount: number
    }
    T7: {
      growthCount: number
      cumulativeCount: number
    }
    T8: {
      growthCount: number
      cumulativeCount: number
    }
    T9: {
      growthCount: number
      cumulativeCount: number
    }
    T10: {
      growthCount: number
      cumulativeCount: number
    }
    T11: {
      growthCount: number
      cumulativeCount: number
    }
    T12: {
      growthCount: number
      cumulativeCount: number
    }
  }
}



export type IListFluctuationYearly = {
  year: number
  ranks: Array<{
    rankId: number
    rankName: string
    customerCount: number
    growthCount: number
    growthRate: number
  }>
  total: {
    rankName: string
    customerCount: number
    growthCount: number
    growthRate: number
  }
}


export type IListMemberTotalByCompanyUnit = {
  id: number
  code: string
  title: string
  parentId: number
  level: number
  ranks: {
    Plantium: number
    Gold: number
    Silver: number
    Member: number
  }
  total: number
  children: Array<{
    id: number
    code: string
    title: string
    parentId: number
    level: number
    ranks: {
      Plantium: number
      Gold: number
      Silver: number
      Member: number
    }
    total: number
    children: Array<any>
  }>
}


export type IComplaintByBusinessTypeAndUnit = {
  id: number
  code: string
  title: string
  parentId: number
  level: number
  values: {
    id: number,
    title: string,
    total: number
  }[],
  total: number
  children: Array<{
    id: number
    code: string
    title: string
    parentId: number
    level: number
    values: {
      id: number,
      title: string,
      total: number
    }[],
    total: number
    children: Array<any>
  }>
}


export type IChartReportRankDemographics = {
  gender: {
    totalCustomer: number
    totalMale: number
    totalFemale: number
    totalElse: number
  }
  businessCheck: {
    totalCustomer: number
    totalIndividual: number
    totalBusiness: number
  }
  statusMarital: {
    totalCustomer: number
    totalSingle: number
    totalMarried: number
    totalElse: number
  }
}

export type IReportMemberCardList = {
  id: number
  name: string
  codeCard: string
  releaseDate: string
  expirationDate: string
  rank: {
    title: string
    icon: string
  }
  status: number
  addType: number
  listCarePolicies: string
}



//Danh sách chăm sóc khách hàng
export const getListReportCustomer = async (
  groupCustomerId?: number[],
  search?: string,
  limit?: number,
  pageNumber?: number,
  dateStart?: string,
  dateEnd?: string,
  unitTempId?: number,
  unitId?: number,
  adminId?: number
) => {
  const path = "report/listCareCustomer"
  const params = {
    groupCustomerId, search, limit, pageNumber, dateStart, dateEnd, unitTempId, unitId, adminId
  }
  const result: ResponseSuccessTotal<IReportCustomer> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getDataCustomerReportGenderBussiness = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportGenderBussiness"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportGenderBussiness> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getDataCustomerReportAgeCar = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "/report/reportOnVehicleDistributionByAge"
  // const path = "report/customerReportAgeCar"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportAge> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getDataCustomerReportJob = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportJob"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportJobs[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getDataCustomerReportAddress = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportAddress"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportAddress[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

////report/customerReportCarOwnedBrand
export const getDataCustomerReportCarOwnedBrand = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportCarOwnedBrand"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportCarOwnedBrand[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

///report/customerReportCarOwnerUsed
export const getDataCustomerReportCarOwnerUsed = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportCarOwnerUsed"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportCarOwnerUsed> = await axiosClient.get(
    path, { params }
  );
  return result;
};

////report/customerReportCarOwnedBrandByUnit
export const getDataCustomerReportCarOwnedBrandByUnit = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/customerReportCarOwnedBrandByUnit"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccessReport<IReportBranchOwnership> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getCustomerByInformationChannel = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/reportCustomerByInformationChannel"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IReportCustomerByInformationChannel[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getVehicleOwnershipReportByBrand = async (
  unitIdDefault: number, limit: number, filter: IDataDefaulFilter
) => {
  const path = "/report/vehicleOwnershipReportByBrand"
  const params = {
    unitIdDefault,
    limit,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<any> = await axiosClient.get(
    path, { params }
  );
  return result;
};



// theo xe sở hữu
export const getVehicleOwnershipReport = async (
  unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "report/vehicleOwnershipReport"
  const params = {
    unitIdDefault,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<IVehicleOwnershipReport> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListVehicleOwnershipReportByBrand = async (
  unitIdDefault: number, limit: number, filter: IDataDefaulFilter
) => {
  const path = "/report/listVehicleOwnershipReportByBrand"
  const params = {
    unitIdDefault,
    limit,
    ...mapFilterToParamsReport(filter)
  }
  const result: ResponseSuccess<any> = await axiosClient.get(
    path, { params }
  );
  return result;
};


// Xuất báo cáo
// export const exportCustomerReportExcel = (
//   unitIdDefault: number,
//   filter: IDataDefaulFilter
// ) => {
//   return axiosClient.get(
//     "/report/exportCustomerReportExcel",
//     {
//       params: {
//         unitIdDefault,
//         ...mapFilterToParamsReport(filter),
//       },
//       responseType: "blob", 
//     }
//   );
// };

export const exportCustomerReportExcel = async (link: string, unitIdDefault: number, filter: IDataDefaulFilter) => {
  try {
    // 1. Kiểm tra URL
    const apiUrl = `${API_URL}${link}`

    const response = await axios.get(apiUrl, {
      params: {
        unitIdDefault: unitIdDefault,
        ...mapFilterToParamsReport(filter),
      },
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    });

    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `bao-cao-khach-hang-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      a.click();
    }

  } catch (error) {
    console.error('Error:', error);
  }

};

export const exportExcelVehicleOwnershipReportByBrand = async (
  title: string, filter: IDataDefaulFilter
) => {
  try {
    // 1. Kiểm tra URL
    const token = tokenService.getToken()
    const apiUrl = `${API_URL}${"report/exportExcelVehicleOwnershipReportByBrand"}`

    const response = await axios.get(apiUrl, {
      params: {
        ...mapFilterToParamsReport(filter)
      },
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title}.xlsx`;
      a.click();
    }

  } catch (error) {
    console.error('Error:', error);
  }

};



export const getListCustomerVehicleOwnershipReportByBrand = async (
  limit: number, pageNumber: number, carBrand: number, type: number, unitIdDefault: number, filter: IDataDefaulFilter
) => {
  const path = "/report/listCustomerVehicleOwnershipReportByBrand"
  const params = {
    limit,
    pageNumber,
    carBrand,
    type,
    unitIdDefault,
    ...mapFilterToParamsReportV2(filter)
  }
  const result: ResponseSuccessTotal<any> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListReportCampaign = async (
  limit?: number, pageNumber?: number, unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaign"
  const params = {
    limit,
    pageNumber,
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccessTotalV3<IReportCampaign[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportCampaignDemographics = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaignDemographics"
  const params = {
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccessTotalV3<IReportCampaignDemographics> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportCampaignVehicleDistributionByAge = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaignVehicleDistributionByAge"
  const params = {
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccess<IReportCampaignVehicleDistributionByAge> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getReportCampaignCustomerAddress = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaignCustomerAddress"
  const params = {
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccess<IReportCampaignCustomerAddress[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getReportCampaignCustomerJob = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaignCustomerJob"
  const params = {
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccess<IReportCampaignCustomerJob[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getReportCampaignCustomerTarget = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  const path = "/report/reportCampaignCustomerTarget"
  const params = {
    unitScopeId,
    status,
    dateCreate,
    dateSend,
    listCampaign,
    listBrand
  }
  const result: ResponseSuccessNonData = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const exportAnalysisMarketingCampaignsExcel = async (
  unitScopeId?: number,
  status?: number[], dateCreate?: string, dateSend?: string,
  listCampaign?: number[], listBrand?: number[]
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportCampaign`
    const response = await axios.get(apiUrl, {
      params: { unitScopeId, status, dateCreate, dateSend, listCampaign, listBrand },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `bao-cao-chien-dich-CSKH-MKT-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};


// báo cáo theo hạng thành viên


export const getListCustomerMemberRankSummary = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/customerMemberRankSummary"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<ICustomerMemberRankSummary> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getChartCustomerReportRank = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/customerReportRank"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IChartCustomerReportRank[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getChartMemberFluctuation = async (
  limit?: number, unitScopeId?: number, listUnit?: number[], listRank?: number[], fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/memberFluctuationChart"
  const params = {
    limit,
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IChartMemberFluctuation[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getListMemberFluctuationYearly = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], fromYear?: string, toYear?: string
) => {
  const path = "/report/memberFluctuationYearly"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromYear,
    toYear
  }
  const result: ResponseSuccess<IListFluctuationYearly[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListMemberGrowthMonthly = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], year?: string,
) => {
  const path = "/report/memberGrowthMonthly"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    year,
  }
  const result: ResponseSuccess<IListMemberGrowthMonthly[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getListMemberTotalByCompanyUnit = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/memberTotalByCompanyUnit"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IListMemberTotalByCompanyUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getChartReportRankDemographics = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[], fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/reportRankDemographics"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IChartReportRankDemographics> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getReportRankCustomerDistributionByAge = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[],
  fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/reportRankCustomerDistributionByAge"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IReportCampaignVehicleDistributionByAgeV2> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportRankCustomerDistributionByRegion = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[],
  fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/reportRankCustomerDistributionByRegion"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IReportCampaignCustomerAddressV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportRankCustomerDistributionByJob = async (
  unitScopeId?: number, listUnit?: number[], listRank?: number[],
  fromMonth?: string, toMonth?: string,
) => {
  const path = "/report/reportRankCustomerDistributionByJob"
  const params = {
    unitScopeId,
    listUnit,
    listRank,
    fromMonth,
    toMonth
  }
  const result: ResponseSuccess<IReportCampaignCustomerJobV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportMemberCardList = async (
  limit?: number, pageNumber?: number, type?: number,
  unitScopeId?: number, businessCheck?: number, gender?: number, statusMarital?: number,
  ageGroup?: number, provinceId?: number, professionId?: number,
  listUnit?: number[], listRank?: number[],
  fromMonth?: string, toMonth?: string, year?: string,
) => {
  const path = "/report/getReportMemberCardList"
  const params = {
    limit, pageNumber, type,
    unitScopeId, businessCheck, gender, statusMarital,
    ageGroup, provinceId, professionId,
    listUnit, listRank,
    fromMonth, toMonth, year
  }
  const result: ResponseSuccessTotal<IReportMemberCardList[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};





export const exportReportMemberCardList = async (
  type?: number,
  unitScopeId?: number, businessCheck?: number, gender?: number, statusMarital?: number,
  ageGroup?: number, provinceId?: number, professionId?: number,
  listUnit?: number[], listRank?: number[],
  fromMonth?: string, toMonth?: string, year?: string,
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportMemberCardList`
    const response = await axios.get(apiUrl, {
      params: {
        type,
        unitScopeId, businessCheck, gender, statusMarital,
        ageGroup, provinceId, professionId,
        listUnit, listRank,
        fromMonth, toMonth, year
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `phat-hanh-the-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};



//#region API cho báo cáo Voucher

export type IReportVoucherByCampaign = {
  id: number
  campaignId: any
  campaignTitle: string
  voucherTitle: string
  type: number
  typeName: string
  typeVoucherId: number
  typeVoucherTitle: string
  totalIssued: number
  totalRedeemed: number
  rateRedeemed: number
}

export type IReportVoucherConversionByCompanyUnit = {
  id: number
  code: string
  title: string
  parentId: number
  level: number
  children: Array<{
    id: number
    code: string
    title: string
    parentId: number
    level: number
    children: Array<any>
    months: {
      T1: number
      T2: number
      T3: number
      T4: number
      T5: number
      T6: number
      T7: number
      T8: number
      T9: number
      T10: number
      T11: number
      T12: number
    }
    total: number
  }>
  months: {
    T1: number
    T2: number
    T3: number
    T4: number
    T5: number
    T6: number
    T7: number
    T8: number
    T9: number
    T10: number
    T11: number
    T12: number
  }
  total: number
}


export type IReportVoucherConversionRateByCompanyUnit = {
  id: number
  code: string
  title: string
  parentId: number
  level: number
  totalIssued: number
  totalRedeemed: number
  rateRedeemed: number
  children: Array<{
    id: number
    code: string
    title: string
    parentId: number
    level: number
    totalIssued: number
    totalRedeemed: number
    rateRedeemed: number
    children: Array<any>
  }>
}
export interface ICustomerVoucher {
  customerId?: number
  customerCodeDms?: string
  dmsId?: string
  idTable?: number
  vehicleId: number
  id: number
  code: string
  name: string
  fields: ListFieldCustomer[]
  groupPermissionId: number
  permissionMenu: PermissionMenu
  originalId: number
  updatedAt: string

  ownerId?: number
  contactId?: number
  priority?: number
  conversionId?: number
  campaignId?: number
  isAutoCampaign?: boolean
  idVoucher?: number
  categoryCarId?: number
}

export const getReportVoucherByCampaign = async (
  limit?: number, offset?: number,
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number


) => {
  const path = "/reportVoucher/reportVoucherByCampaign"
  const params = {
    limit, offset,
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId

  }
  const result: ResponseSuccessTotalReportVoucher<IReportVoucherByCampaign[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getReportVoucherConversionByCompanyUnit = async (
  // limit?: number, offset?: number,
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  // dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number,
  year?: number


) => {
  const path = "/reportVoucher/voucherConversionByCompanyUnit"
  const params = {
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId,

    year

  }
  const result: ResponseSuccessTotalReportVoucher<IReportVoucherConversionByCompanyUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getReportVoucherConversionRateByCompanyUnit = async (
  // limit?: number, offset?: number,
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number


) => {
  const path = "/reportVoucher/voucherConversionRateByCompanyUnit"
  const params = {
    // limit, offset,
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId

  }
  const result: ResponseSuccessTotalReportVoucher<IReportVoucherConversionRateByCompanyUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getReportVoucherDemographics = async (
  // limit?: number, offset?: number,
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number

) => {
  const path = "/reportVoucher/reportVoucherDemographics"
  const params = {
    // limit, offset,
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId
  }
  const result: ResponseSuccessTotal<IChartReportRankDemographics> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getReportVoucherCustomerDistributionByAge = async (
  // limit?: number, offset?: number,
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number

) => {
  const path = "/reportVoucher/reportVoucherCustomerDistributionByAge"
  const params = {
    // limit, offset,
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId
  }
  const result: ResponseSuccessTotal<IReportCampaignVehicleDistributionByAgeV2> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportVoucherCustomerDistributionByRegion = async (
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number

) => {
  const path = "/reportVoucher/reportVoucherCustomerDistributionByRegion"
  const params = {
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId
  }
  const result: ResponseSuccessTotal<IReportCampaignCustomerAddressV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getReportVoucherCustomerDistributionByJob = async (
  unitScopeId?: number, listUnit?: number[], listCampaignIds?: number[],
  // (YYYY-MM-DD)
  dateStart?: string, dateEnd?: string,
  // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  type?: number,
  typeVoucherId?: number

) => {
  const path = "/reportVoucher/reportVoucherCustomerDistributionByJob"
  const params = {
    unitScopeId, listUnit, listCampaignIds,
    // (YYYY-MM-DD)
    dateStart, dateEnd,
    // Loại hình voucher (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
    type,
    typeVoucherId
  }
  const result: ResponseSuccessTotal<IReportCampaignCustomerJobV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// info
export const getInforCustomerReportVoucherCustomerList = async (


  limit?: number, pageNumber?: number,
  // Loại báo cáo (hoặc type): 0: Báo cáo voucher chiến dịch, 1: Báo cáo quy đổi tại cty theo tháng, 2: Báo cáo quy đổi cty tỉnh thành, 3: Nhân khẩu học, 4: Độ tuổi, 5: Khu vực, 6: Nghề nghiệp
  reportType?: number,
  unitScopeId?: number,
  listUnit?: number[], listCampaignIds?: number[],
  // Loại hình voucher (hoặc type) (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  voucherType?: number,

  typeVoucherId?: number,
  dateStart?: string, dateEnd?: string,
  year?: number,
  businessCheck?: number,
  gender?: number,
  statusMarital?: number,
  ageGroup?: number,
  provinceId?: number,
  professionId?: number,

) => {
  const path = "/reportVoucher/getReportVoucherCustomerList"
  const params = {
    limit, pageNumber, reportType,
    unitScopeId, listUnit, listCampaignIds,
    voucherType, typeVoucherId, dateStart, dateEnd, year,
    businessCheck, gender, statusMarital, ageGroup, provinceId, professionId
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// info table đơn vị theo tỉnh thành
export const getCustomerListByCompanyUnit = async (

  limit?: number, pageNumber?: number,
  // Loại danh sách: 1: Số phát hành, 2: Số quy đổi
  unitId?: number,
  listCampaignIds?: number[],
  // Loại hình voucher (hoặc type) (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  voucherType?: number,

  typeVoucherId?: number,
  dateStart?: string, dateEnd?: string,


) => {
  const path = "/reportVoucher/getCustomerListByCompanyUnit"
  const params = {
    limit, pageNumber,
    unitId, listCampaignIds,
    voucherType, typeVoucherId, dateStart, dateEnd,
  }
  const result: ResponseSuccessTotal<ICustomerVoucher[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//#region  xuất export chiến dịch

export const exportReportCampaignDemographics = async (
  search?: string, unitScopeId?: number,
  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  gender?: number, businessCheck?: number, statusMarital?: number,
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportCampaignDemographics`
    const response = await axios.get(apiUrl, {
      params: {
        search, unitScopeId,
        listCampaign, listBrand, status, dateCreate, dateSend,
        gender, businessCheck, statusMarital,
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-bao-cao-nhan-khau-hoc-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportReportCampaignVehicleDistributionByAge = async (
  unitScopeId?: number,
  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  age?: number
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportCampaignVehicleDistributionByAge`
    const response = await axios.get(apiUrl, {
      params: {
        unitScopeId,
        listCampaign, listBrand, status, dateCreate, dateSend,
        age
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-bao-cao-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportReportCampaignCustomerAddress = async (
  unitScopeId?: number,
  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  addressId?: number[]
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportCampaignCustomerAddress`
    const response = await axios.get(apiUrl, {
      params: {
        unitScopeId,
        listCampaign, listBrand, status, dateCreate, dateSend,
        addressId
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-bao-cao-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportReportCampaignCustomerJob = async (
  unitScopeId?: number,
  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  jobId?: number[]
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportReportCampaignCustomerJob`
    const response = await axios.get(apiUrl, {
      params: {
        unitScopeId,
        listCampaign, listBrand, status, dateCreate, dateSend,
        jobId
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-bao-cao-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

// #endregion

//#region  xuất export Báo cáo tổng quan
export const exportInforCustomerReportGenderBussiness = async (
  search?: string,
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  typeBussiness?: number, typeGender?: number
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportInforCustomerReportGenderBussiness`
    const response = await axios.get(apiUrl, {
      params: {
        search,
        unitIdDefault, unitId,
        businessCheck, gender, job,
        province, carBrand,
        groupCustomer, age,
        typeBussiness, typeGender
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-bao-cao-gioi-tinh-va-phan-loai-khach-hang-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportInforCustomerReportAddress = async (
  search?: string, provinceId?: number[],
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  // typeBussiness?: number, typeGender?: number
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportInforCustomerReportAddress`
    const response = await axios.get(apiUrl, {
      params: {
        search, provinceId,
        unitIdDefault, unitId,
        businessCheck, gender, job,
        province, carBrand,
        groupCustomer, age,
        // typeBussiness, typeGender
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-bao-cao-theo-tinh-thanh-pho-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportInforCustomerReportJob = async (
  search?: string, jobId?: number[],
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  // typeBussiness?: number, typeGender?: number
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}/report/exportInforCustomerReportJob`
    const response = await axios.get(apiUrl, {
      params: {
        search, jobId,
        unitIdDefault, unitId,
        businessCheck, gender, job,
        province, carBrand,
        groupCustomer, age,
        // typeBussiness, typeGender
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-bao-cao-theo-nghe-nghiep-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

// #endregion

// xuất export
export const exportReportVoucherCustomerList = async (
  reportType?: number,
  unitScopeId?: number,
  listUnit?: number[], listCampaignIds?: number[],
  // Loại hình voucher (hoặc type) (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  voucherType?: number,

  typeVoucherId?: number,
  dateStart?: string, dateEnd?: string,
  year?: number,
  businessCheck?: number,
  gender?: number,
  statusMarital?: number,
  ageGroup?: number,
  provinceId?: number,
  professionId?: number,
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}reportVoucher/exportReportVoucherCustomerList`
    const response = await axios.get(apiUrl, {
      params: {
        reportType,
        unitScopeId, listUnit, listCampaignIds,
        voucherType, typeVoucherId, dateStart, dateEnd, year,
        businessCheck, gender, statusMarital, ageGroup, provinceId, professionId
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-tu-bao-cao-voucher-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportCustomerListByCompanyUnit = async (
  unitId?: number,
  listCampaignIds?: number[],
  // Loại hình voucher (hoặc type) (0 - Công khai, 1 - Theo nhóm, 2 - Theo cá nhân)
  voucherType?: number,

  typeVoucherId?: number,
  dateStart?: string, dateEnd?: string,
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}reportVoucher/exportCustomerListByCompanyUnit`
    const response = await axios.get(apiUrl, {
      params: {
        unitId, listCampaignIds,
        voucherType, typeVoucherId, dateStart, dateEnd,
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-theo-don-vi-phat-hanh-quy-doi-voucher-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const exportInforCustomerReportOnVehicleDistributionByAge = async (
  search?: string,

  age?: number[],
  vehicleType?: string,

  unitIdDefault?: number,
  unitId?: number[],

  businessCheck?: number[],
  gender?: number[],
  job?: number[],
  province?: number[],
  carBrand?: number[],
  groupCustomer?: number[],
) => {
  try {

    const token = tokenService.getToken()
    const apiUrl = `${API_URL}report/exportInforCustomerReportOnVehicleDistributionByAge`
    const response = await axios.get(apiUrl, {
      params: {
        search,
        age,
        vehicleType,
        unitIdDefault,
        unitId,
        businessCheck,
        gender,
        job,
        province,
        carBrand,
        groupCustomer,
      },
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `File-Excel-danh-sach-khach-hang-bao-cao-phan-bo-xe-theo-do-tuoi-${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};
//#endregion


// API chi tiết báo cáo

export type IInforCustomerReportGenderBussiness = {
  id: number
  code: string
  priority: number
  name: string
  updatedAt: string
  fields: Array<{
    fieldId: number
    fieldLabel: string
    fieldCode: string
    value: any
    view: boolean
  }>
  groupPermissionId: number
  permissionMenu: {
    groupPermissionId: number
    view: boolean
    edit: boolean
    delete: boolean
  }
}

export const getInforCustomerReportOnVehicleDistributionByAge = async (
  limit?: number,
  pageNumber?: number,
  search?: string,

  age?: number[],
  vehicleType?: string,

  unitIdDefault?: number,
  unitId?: number[],

  businessCheck?: number[],
  gender?: number[],
  job?: number[],
  province?: number[],
  carBrand?: number[],
  groupCustomer?: number[],
) => {
  const path = "/report/inforCustomerReportOnVehicleDistributionByAge"
  const params = {
    limit,
    pageNumber,
    search,
    age,
    vehicleType,
    unitIdDefault,
    unitId,
    businessCheck,
    gender,
    job,
    province,
    carBrand,
    groupCustomer,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerReportGenderBussiness = async (
  limit?: number, pageNumber?: number, search?: string,
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  typeBussiness?: number, typeGender?: number
) => {
  const path = "/report/inforCustomerReportGenderBussiness"
  const params = {
    limit, pageNumber, search,
    unitIdDefault, unitId,
    businessCheck, gender, job,
    province, carBrand,
    groupCustomer, age,
    typeBussiness, typeGender
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getInforCustomerReportJob = async (
  limit?: number, pageNumber?: number, search?: string,
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  jobId?: number[],
) => {
  const path = "/report/inforCustomerReportJob"
  const params = {
    limit, pageNumber, search,
    unitIdDefault, unitId,
    businessCheck, gender, job,
    province, carBrand,
    groupCustomer, age,
    jobId,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};




export const getInforCustomerReportAddress = async (
  limit?: number, pageNumber?: number, search?: string,
  unitIdDefault?: number, unitId?: number[],
  businessCheck?: number[], gender?: number[], job?: number[],
  province?: number[], carBrand?: number[],
  groupCustomer?: number[], age?: number[],
  provinceId?: number[],
) => {
  const path = "/report/inforCustomerReportAddress"
  const params = {
    limit, pageNumber, search,
    unitIdDefault, unitId,
    businessCheck, gender, job,
    province, carBrand,
    groupCustomer, age,
    provinceId,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerReportCampaignDemographics = async (
  limit?: number, pageNumber?: number, search?: string, unitScopeId?: number,
  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  gender?: number, businessCheck?: number, statusMarital?: number,
) => {
  const path = "/report/inforCustomerReportCampaignDemographics"
  const params = {
    limit, pageNumber, search, unitScopeId,
    listCampaign, listBrand, status, dateCreate, dateSend,
    gender, businessCheck, statusMarital,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getInforCustomerReportCampaignVehicleDistributionByAge = async (
  limit?: number, pageNumber?: number, search?: string, unitScopeId?: number,

  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  unitId?: number[], channelId?: number, gender?: number, businessCheck?: number, province?: number[], groupCustomer?: number[], carBrand?: number[], job?: number[],
  age?: number,
) => {
  const path = "/report/inforCustomerReportCampaignVehicleDistributionByAge"
  const params = {
    limit, pageNumber, search, unitScopeId,
    listCampaign, listBrand, status, dateCreate, dateSend,
    unitId, channelId, gender, businessCheck, province, groupCustomer, carBrand, job,
    age,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerReportCampaignCustomerAddress = async (
  limit?: number, pageNumber?: number, search?: string, unitScopeId?: number,

  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  addressId?: number[],
) => {
  const path = "/report/inforCustomerReportCampaignCustomerAddress"
  const params = {
    limit, pageNumber, search, unitScopeId,
    listCampaign, listBrand, status, dateCreate, dateSend,
    addressId,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerReportCampaignCustomerJob = async (
  limit?: number, pageNumber?: number, search?: string, unitScopeId?: number,

  listCampaign?: number[], listBrand?: number[], status?: number[], dateCreate?: string, dateSend?: string,
  jobId?: number[],
) => {
  const path = "/report/inforCustomerReportCampaignCustomerJob"
  const params = {
    limit, pageNumber, search, unitScopeId,
    listCampaign, listBrand, status, dateCreate, dateSend,
    jobId,
  }
  const result: ResponseSuccessTotal<IInforCustomerReportGenderBussiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//#region  Báo cáo Tổng quan phàn nàn/ khiếu nại
export interface IReportComplaintStatisticsComplaint {
  total: number
  totalProcessing: number
  totalClosed: number
  totalUnknown: number
}
export interface IReportTopComplaintChannels {
  total: number
  name: string
}

export interface IReportComplaintByBusinessType {
  values: {
    "Kinh doanh": number
    "Dịch vụ": number
    "Khác": number
  }

}

export interface IReportComplaintByBusinessTypeAndBrand {
  brands: (string | { id: number; title: string })[]
  rows: Row[]
}

export interface Row {
  id?: number
  name: string
  total: number
  values: Record<string, number> | { id: number; title: string; total: number }[]
  children: Children[]
}

export interface Children {
  id?: number
  name: string
  total: number
  values: Record<string, number> | { id: number; title: string; total: number }[]
  children: Children[]
}



export const getReportComplaintByBusinessTypeAndBrand = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "reportComplaint/complaintByBusinessTypeAndBrand"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IReportComplaintByBusinessTypeAndBrand> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getReportComplaintStatisticsComplaint = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "/reportComplaint/statisticsComplaint"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IReportComplaintStatisticsComplaint> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportComplaintByBusinessType = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string,
) => {
  const path = "/reportComplaint/complaintByBusinessType"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IReportComplaintByBusinessType> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getReportTopComplaintChannels = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string, top?: number,
) => {
  const path = "/reportComplaint/topComplaintChannels"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
    top
  }
  const result: ResponseSuccess<IReportTopComplaintChannels[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListComplaintByBusinessTypeAndUnit = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "/reportComplaint/complaintByBusinessTypeAndUnit"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate, // (YYYY-MM-DD)
  }
  const result: ResponseSuccess<IComplaintByBusinessTypeAndUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListComplaintBusinessDdmsByUnit = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "/reportComplaint/complaintBusinessDdmsByUnit"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IComplaintByBusinessTypeAndUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListComplaintServiceDdmsByUnit = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "/reportComplaint/complaintServiceDdmsByUnit"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IComplaintByBusinessTypeAndUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListComplaintOtherDdmsByUnit = async (
  unitScopeId?: number, listUnit?: number[], dateCreate?: string
) => {
  const path = "/reportComplaint/complaintOtherIpccByUnit"
  const params = {
    unitScopeId,
    listUnit,
    dateCreate,
  }
  const result: ResponseSuccess<IComplaintByBusinessTypeAndUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
// Chi tiết
export interface IReportComplaintDetail {
  id: number
  customerName: string
  customerCode: string
  phone: string
  complaintType: string
  complaintContent: string
  status: string
  createdDate: string
  unitName: string
}

export const getReportComplaintDetailList = async (
  unitId: number,
  businessType?: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintByBusinessTypeAndUnit"
  const params = {
    unitId, businessType, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerTopComplaintChannel = async (
  channel: string,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  top?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerTopComplaintChannel"
  const params = {
    channel, dateCreate, listUnit, unitScopeId, top, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerComplaintByBusinessType = async (
  businessType: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintByBusinessType"
  const params = {
    businessType, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerComplaintBusinessDdmsByUnit = async (
  unitId: number,
  categoryId: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintBusinessDdmsByUnit"
  const params = {
    unitId, categoryId, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerComplaintServiceDdmsByUnit = async (
  unitId: number,
  categoryId: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintServiceDdmsByUnit"
  const params = {
    unitId, categoryId, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerComplaintOtherIpccByUnit = async (
  unitId: number,
  categoryId: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintOtherIpccByUnit"
  const params = {
    unitId, categoryId, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerComplaintByBusinessTypeAndBrand = async (
  categoryId: number,
  brandId: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerComplaintByBusinessTypeAndBrand"
  const params = {
    categoryId, brandId, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInforCustomerStatisticsComplaint = async (
  group: number,
  dateCreate?: string,
  listUnit?: number[],
  unitScopeId?: number,
  limit?: number,
  pageNumber?: number,
) => {
  const path = "/reportComplaint/inforCustomerStatisticsComplaint"
  const params = {
    group, dateCreate, listUnit, unitScopeId, limit, pageNumber,
  }
  const result: ResponseSuccessTotal<IReportComplaintDetail[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//#endregion